import { FC } from "react";

import { Checkmark } from "shared/assets/icons";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { colors } from "shared/styles/constants";

import { LabelProps, Label } from "Bands/containers/BandToggle/components";

export const ActiveLabel: FC<LabelProps> = (props) => (
  <Spacer spaceDirection="horizontal" size="s" align="center">
    <Label {...props} />
    <Icon as={Checkmark} color={colors.green} />
  </Spacer>
);
